<rk-card
  [name]="title"
  [hasError]="criteriaForm.invalid"
  (removeAction)="deleteCriteria.emit(index)"
>
  <ng-container [formGroup]="criteriaForm">
    <div class="criteria flex flex-col">
      <rk-dropdown-autocomplete
        [data]="generateOperatorsInput()"
        formControlName="operator"
      ></rk-dropdown-autocomplete>
      <ng-container *ngIf="isTextInput(); else chipsInput">
        <rk-dropdown-autocomplete [data]="$boxes()" formControlName="value">
        </rk-dropdown-autocomplete>
      </ng-container>
      <ng-template #chipsInput>
        <rk-form-field>
          <rk-chips-input
            [style.margin-bottom.px]="criteriaForm.get('chipsValue').value.length ? 5 : 0"
            formControlName="chipsValue"
            [dataFetched]="$boxes()"
            [canAddNew]="false"
          ></rk-chips-input>
        </rk-form-field>
      </ng-template>
    </div>
  </ng-container>
</rk-card>
